import React from 'react';

const useForceUpdate = () => {
  const [, updateState] = React.useState();
  return React.useCallback(() => updateState({}), []);
};

export default useForceUpdate;
